import { KEY_CODE } from '@fmpedia/enums';

const DEFAULT_BINDING_PROPS = {
  attachTabIndex: true,
  tabIndexValue: 0
};

const focusable = (() => {
  const state = new WeakMap();

  const getOnKeyDownHandler = (el) => (event) => {
    if (event.target !== el) return

    if (
      event.keyCode === KEY_CODE.ENTER ||
      event.keyCode === KEY_CODE.SPACEBAR
    ) {
      event.preventDefault();
      event.target.click();
    }
  };

  return {
    inserted(el, binding) {
      const props = Object.assign(
        {},
        DEFAULT_BINDING_PROPS,
        binding.value || {}
      );

      if (props.attachTabIndex) {
        el.setAttribute('tabindex', props.tabIndexValue);
      }

      const onKeyDown = getOnKeyDownHandler(el);

      state.set(el, { onKeyDown });

      el.addEventListener('keydown', onKeyDown);
    },
    unbind(el) {
      const { onKeyDown } = state.get(el);

      el.removeEventListener('keydown', onKeyDown);

      state.delete(el);
    }
  }
})();

export { focusable };
